<template>  
    <div class="news-publisher">  
      <!-- 上传组件 -->  
      <el-upload  
        class="avatar-upload"  action="" 
        multiple :limit="1" name="file"
        :show-file-list="false"
        :http-request="handleRequest"   
        :before-upload="beforeUpload"  
        accept="image/*"  
      >  
        <el-button slot="trigger" size="small" type="text">上传图片</el-button>  
        <!-- <div slot="tip" class="red">只能上传jpg/png文件，且不超过1M</div>   -->
      </el-upload> 
      <quill-editor  
        class="ql-snow"
        v-model="content"  
        ref="myQuillEditor" 
        :options="editorOptions"  
        @change="onEditorChange"  
      />       
    </div>  
</template>      
<script>  
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.snow.css'

export default {    
  components: { 
      quillEditor
  },
  data() {  
    return {  
      content: '',
      imageUrl: '',  
      editorOptions: { 
        placeholder: '请输入正文', 
        theme: 'snow',  
        modules: {  
          toolbar: [  
            [{ header: 1 }, { header: 2 }],  
            ['bold', 'italic', 'underline'],    
            [{ indent: '-1' }, { indent: '+1' }],
            [{ 'size': ['small',false, 'large', 'huge'] }],
            // [{ 'size': ['14', '16', '18','20', '22', '28', '32'] }],
            // [{ 'font': ['SimSun', 'Arial', 'Microsoft YaHei'] }],
            // [{ 'color': [] }, { 'background': [] }]

            [{ color: [] }, { background: [] }],
            [{ 'list': 'ordered'}, { 'list': 'bullet' }],  
            [{ align: [] }],
            ['clean'],

            // ['link', 'image'], 
          ],           
        },      
      }  
    };  
  },  
  methods: {  
    onEditorChange({ html, text }) {  
      this.content = html;  
      this.$emit('update:value',html)
    },  
    // 修改新闻的时候回显方法
    editNews(html){
      this.content = html;
    },
    async handleRequest(file,fileList){
      let fileUrl = await this.$help.uploadRequest(file)
      let url = this.$global.uploadUrl + fileUrl
      
      this.imageUrl  = url
      // 插入图片
      const quill = this.$refs.myQuillEditor.quill;  
      const length = quill.getSelection().index; 
      const range = quill.getSelection(); 
      quill.insertEmbed(length, 'image', url);  
      quill.setSelection(range.index + 1) // 移动光标  
      // console.log('插入图片1', url)
      this.$refs.myQuillEditor.clearFiles()
    },  
    insertImage(url) { 
      // console.log('插入图片0', url) 
      // 使用 Quill 的 API 插入图片  
      const quill = this.$refs.myQuillEditor.quill;  
      const range = quill.getSelection();  
      quill.insertEmbed(range.index, 'image', url);
      quill.setSelection(range.index + 1) // 移动光标  
      // console.log('插入图片2', url)
      // 插入后清空 imageUrl，除非你想让用户连续插入多张图片而不重新上传  
      this.imageUrl = '';  
    },  
     beforeUpload(file){
      // 在上传之前可以对文件进行校验   0.5是 500kb 3是3MB
      const isImage = file.type.startsWith('image/');  
      const isLt3M = file.size / 1024 / 1024 < 3;  
      if (!isImage) {  
        this.$message.error('上传文件只能是图片！');  
      }  
      if (!isLt3M) {  
        // this.$message.error('上传图片大小不能超过 500KB！');  
        // console.log("图片大于3M");
        const reader = new FileReader();        
        reader.readAsDataURL(file);
        
        reader.onload =  ()=> {
            const img = new Image();
            img.src = reader.result ;
            img.onload = async ()=> {
                const canvas = document.createElement("canvas");
                const ctx = canvas.getContext("2d");
                const maxWidth = 800; // 设置最大宽度为500px
                const maxHeight = 800; //设置最大高度为500px
                let width = img.width;
                let height = img.height;

                console.log(width,height)
                // 计算压缩比例
                if (width > height) {
                    if (width > maxWidth) {
                        height *= maxWidth / width;
                        width = maxWidth;
                    }
                } else {
                    if (height > maxHeight) {
                        width *= maxHeight / height;
                        height = maxHeight;
                    }
                }
                // console.log(width,height)
                 // 设置canvas的宽高
                canvas.width = width;
                canvas.height = height;
                // 将图片绘制到canvas上
                ctx.drawImage(img, 0, 0, width, height);
 
                // 将canvas转换为base64格式并上传
                const compressedImageBase64 = canvas.toDataURL("image/jpg", 1); // 0.9为图片质量，可根据需求调整
                // console.log('==',compressedImageBase64)
                let baseUrl = await this.$help.uploadFile(compressedImageBase64)
                let imageUrl = this.$global.uploadUrl + baseUrl
                 // 插入图片
                const quill = this.$refs.myQuillEditor.quill;  
                const length = quill.getSelection().index;  
                const range = quill.getSelection();
                quill.insertEmbed(length, 'image', imageUrl);  
                quill.setSelection(range.index + 1) // 移动光标  
                // console.log('插入图片0', imageUrl)
            }
        }
      }  
      return isImage && isLt3M;  
    },   
  }  
};  
</script>  
  
<style lang="scss" scoped>  
.news-publisher {  
  // max-width: 1000px;  
  // margin: 0 auto;  
  // padding: 20px;  
  position: relative;

}  
.avatar-upload{
  position: absolute;
  top: 10px;
  left: 56%;
} 
.quill-editor{  
  height: 600px !important;  
}  
    
/deep/ {
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="14"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="14"]::before {
  content: '14px';
  vertical-align: top;
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="16"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="16"]::before {
  content: '16px';
  vertical-align: top;
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="18"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="18"]::before {
  content: '18px';
  vertical-align: top;
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="20"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="20"]::before {
  content: '20px';
  vertical-align: top;
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="22"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="22"]::before {
  content: '22px';
  vertical-align: top;
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="24"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="24"]::before {
  content: '24px';
  vertical-align: top;
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="28"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="28"]::before {
  content: '28px';
  vertical-align: top;
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="32"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="32"]::before {
  content: '32px';
  vertical-align: top;
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="36"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="36"]::before {
  content: '36px';
  vertical-align: top;
}

 /* 这个是字号数字对应的px值 */
    .ql-editor .ql-size-14 {
    font-size: 14px;
    }
    .ql-editor .ql-size-16 {
    font-size: 16px;
    }
    .ql-editor >>> .ql-size-18 {
    font-size: 18px !important;
    }
    .ql-editor >>> .ql-size-20 {
    font-size: 20px !important;;
    }
    .ql-editor .ql-size-22 {
    font-size: 22px;
    }
    .ql-editor .ql-size-24 {
    font-size: 24px;
    }
    .ql-editor .ql-size-28 {
    font-size: 28px;
    }
    .ql-editor .ql-size-32 {
    font-size: 32px;
    }
    .ql-editor .ql-size-36 {
    font-size: 36px;
    }
/* 选择字号富文本字的大小 */
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="14"]::before {
  font-size: 14px;
  }
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="16"]::before {
  font-size: 16px;
  }
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="18"]::before {
  font-size: 18px !important;
  }
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="20"]::before {
  font-size: 20px;
  }
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="22"]::before {
  font-size: 22px;
  }
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="24"]::before {
  font-size: 24px;
  }
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="28"]::before {
  font-size: 28px;
  }
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="32"]::before {
  font-size: 32px;  
  }
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="36"]::before {
  font-size: 36px;
  }  
}

</style>


// WEBPACK FOOTER //
// src/components/NewsPublisher.vue